import React, { useState } from 'react';
import { I } from '../../../common/v5/config';
import Helper from '../../../reactcomponents/Helper';
import Button from '../../../reactcomponents/Button';
import '../../../styles/v5/agent/agent-upload-form.css';

const AgentUploadForm = ({ onClose, onUpload, onDownloadTemplate }) => {
  const [status, setStatus] = useState(I("Upload agent list by uploading CSV or Excel file."));
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (event) => {
    event.preventDefault();
    setIsUploading(true);
    setStatus(I("Uploading file..."));
    
    const files = event.target.files;
    if (files && files.length > 0) {
      const formData = new FormData();
      const boundary = Math.floor(Math.random() * 6) + '0' + Math.floor(Date.now() / 1000);
      
      formData.append('uploadfile', files[0]);
      formData.append('fileNameOnly', files[0].name);
      formData.append('eventType', 'upload');
      formData.append('random', parseFloat(boundary));         
      if (onUpload) {
        onUpload(formData);
        setStatus(I("File uploaded successfully! Processing agents in background..."));
        setTimeout(() => {
          onClose();
        }, 2000);
      }
    }
    
    setIsUploading(false);
    event.target.value = '';
  };

  const handleDownloadTemplate = () => {
    if (onDownloadTemplate) {
      onDownloadTemplate();
    } else {
      // Default template download logic
      const exportFilename = 'agent_list.csv';
      const csv = 'Login_Name,Password,Admin_Level,User_Name,Email_Address,External_ID,Bright_Reference_Code,Signature_Name,Chat_Name\n';
      const csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, exportFilename);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(csvData);
        link.setAttribute('download', exportFilename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  return (
    <div className="agent-upload-form">
      <div className="upload-content">
        <div className="upload-description">
          <p className="description-text">
            {I("Download template and upload the file with the following information:")}
          </p>
          <p className="info-text">
            {I("Login, password, administration level, name of the agent, email address, signature name, chat alias (if chat is used) etc.")}
          </p>
          <p className="example-text">
            <strong>{I("Example:")}</strong><br />
            {I("Joer, a123, Administrator, John Ericsson, john@cention.se, John, John")}
          </p>
        </div>
        
        <div className="upload-controls">
          <div className="upload-buttons">
            <div className="file-input-wrapper">
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                className="file-input"
                id="agentUploadFile"
              />
              <label htmlFor="agentUploadFile" className="btn btn-primary upload-btn">
                <i className="icon-upload"></i>
                {I("Choose File")}
              </label>
            </div>
            
            <Button
              type="button"
              className="btn btn-outline-secondary template-btn"
              onClick={handleDownloadTemplate}
              text={I('Download Template')}
            />
          </div>
          
          <div className="upload-info">
            <Helper>
              {I("Supported file types: CSV and Excel files")}
            </Helper>
          </div>
        </div>
        
        <div className="upload-status">
          <div className="status-message">{status}</div>
          {isUploading && (
            <div className="upload-progress">
              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <div className="upload-actions">
        <Button
          type="button"
          className="btn btn-secondary"
          onClick={onClose}
          text={I('Close')}
        />
      </div>
    </div>
  );
};

export default AgentUploadForm; 